module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iNDAwIiB2aWV3Qm94PSIwIDAgMyAyIj48cGF0aCBmaWxsPSIjMDAyQjdGIiBkPSJNMCAwaDN2MkgweiIvPjxwYXRoIGZpbGw9IiNGQ0QxMTYiIGQ9Ik0xIDBoMnYySDF6Ii8+PHBhdGggZmlsbD0iI0NFMTEyNiIgZD0iTTIgMGgxdjJIMnoiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/rou.svg
// module id = c1R1
// module chunks = 0